import React from 'react';
import { Field } from 'formik';
import { Input } from '@fourthwall/components';
import { TinyMCE } from '@components/adapters/inputs/TinyMCE';
import * as S from './styled';
export const ProductSection = ({ index }) => (React.createElement(React.Fragment, null,
    React.createElement(S.TitleWrapper, null,
        React.createElement(Field, { name: `additionalSections[${index}].title`, component: Input, label: "Title" })),
    React.createElement(Field, { name: `additionalSections[${index}].bodyHtml`, component: TinyMCE, buttons: { code: true } })));
